<span
  >Ein Update ist verfügbar und wird in {{ data.countdown | async }} Sekunden aktiviert.<br />Bitte
  speichern Sie jetzt noch nicht gespeicherte Änderungen.</span
>

<div class="mat-simple-snackbar-action">
  <button mat-button (click)="action()">Jetzt aktivieren</button>
</div>
